import type { IconProps } from '../create-icon'

export function SteamLogo({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <path d="M11.979 0C5.678 0 .511 4.86.022 10.94l6.432 2.658a3.387 3.387 0 0 1 1.912-.588c.063 0 .125.003.187.006l2.861-4.142V8.77a4.508 4.508 0 0 1 4.507-4.507 4.508 4.508 0 0 1 4.507 4.507 4.508 4.508 0 0 1-4.507 4.508h-.105l-4.076 2.91c0 .052.004.105.004.159a3.388 3.388 0 0 1-3.388 3.388 3.394 3.394 0 0 1-3.322-2.727L.378 14.07C1.701 19.674 6.36 24 11.979 24 18.627 24 24 18.627 24 11.979 24 5.37 18.627 0 11.979 0ZM7.518 18.493l-1.46-.604a2.54 2.54 0 0 0 2.308 1.527 2.544 2.544 0 0 0 2.544-2.541 2.546 2.546 0 0 0-2.539-2.546 2.535 2.535 0 0 0-1.29.352l1.508.625a1.874 1.874 0 0 1-1.434 3.46l-.003-.003.002.002-.002-.002.003.003a1.87 1.87 0 0 1 .363-3.274Zm8.405-6.22a3.008 3.008 0 0 0 3.004-3.005 3.008 3.008 0 0 0-3.004-3.005 3.008 3.008 0 0 0-3.005 3.005 3.008 3.008 0 0 0 3.005 3.005Zm-.004-4.509a1.505 1.505 0 1 1 0 3.01 1.505 1.505 0 0 1 0-3.01Z" />
    </svg>
  )
}
